(function () {
  'use strict';

  angular.module('wsLrs.directives').
  //modify external links to open in new window and have an icon after the link
  directive('wsExtHref', function () {
    return {
      compile: function compile(element) {
        var link = element.attr('ws-ext-href');
        element.attr('target', '_blank');
        element.attr('href', link);
        element.append("&nbsp;<span class='glyphicon glyphicon-new-window'></span>");
      }
    };
  });
})();
